export default "__VITE_ASSET__571fcac1__"